import domReady from "@wordpress/dom-ready";
import { swiperCreateNew } from "./swiper-settings";

const initSwipers = () => {
	const allCarouselSections = document.querySelectorAll(
		".wp-block-theme-blocks-slider-posts",
	);
	allCarouselSections?.forEach((section) => {
		const thisSwiper = swiperCreateNew(section.id);
	});
};

domReady(() => {
	initSwipers();
});

window.addEventListener("load", () => {
	// initSwipers();
});
